import React, { useState } from 'react';
import { getAdminRemoteEntryUrl } from '../utils/admin-url';

interface AdvancedOptionsProps {
  onRemoteUrlChange: (url: string) => void;
  currentUrl: string;
}

export function AdvancedOptions({ onRemoteUrlChange, currentUrl }: AdvancedOptionsProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [customUrl, setCustomUrl] = useState(currentUrl);

  const commonUrls = [
    ...new Set([
      getAdminRemoteEntryUrl(),
      'https://beta-admin.clarke.com.br/remoteEntry.js',
      'https://admin.clarke.com.br/remoteEntry.js',
      'http://localhost:3000/remoteEntry.js',
    ]),
  ];

  const handleUrlChange = (url: string) => {
    setCustomUrl(url);
    onRemoteUrlChange(url);
  };

  const testBrowserCompatibility = () => {
    const results = {
      moduleSupport: 'noModule' in HTMLScriptElement.prototype,
      dynamicImport: typeof window !== 'undefined' && 'import' in window,
      esModules: typeof Symbol !== 'undefined' && Symbol.toStringTag,
      fetch: typeof fetch !== 'undefined',
      cors: typeof XMLHttpRequest !== 'undefined',
    };

    return results;
  };

  return (
    <div className="mb-6 border border-neutral-20 dark:border-neutral-70 rounded-lg bg-white dark:bg-neutral-90">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 text-left flex justify-between items-center hover:bg-neutral-5 dark:hover:bg-neutral-85 transition-colors"
      >
        <h3 className="font-semibold text-neutral-90 dark:text-white">⚙️ Advanced Options</h3>
        <span className="text-neutral-60 dark:text-neutral-40">{isExpanded ? '▼' : '▶'}</span>
      </button>

      {isExpanded && (
        <div className="p-4 border-t border-neutral-20 dark:border-neutral-70 space-y-4">
          <div>
            <label className="block text-sm font-medium text-neutral-90 dark:text-white mb-2">Remote URL</label>
            <input
              type="url"
              value={customUrl}
              onChange={(e) => handleUrlChange(e.target.value)}
              className="w-full p-2 border border-neutral-20 dark:border-neutral-70 rounded bg-white dark:bg-neutral-80 text-neutral-90 dark:text-white"
              placeholder="https://example.com/remoteEntry.js"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-90 dark:text-white mb-2">Quick Select</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {commonUrls.map((url) => (
                <button
                  key={url}
                  onClick={() => handleUrlChange(url)}
                  className={`p-2 text-left text-xs border rounded transition-colors ${
                    customUrl === url
                      ? 'border-primary-50 bg-primary-5 dark:bg-primary-90/20 text-primary-70 dark:text-primary-30'
                      : 'border-neutral-20 dark:border-neutral-70 hover:bg-neutral-5 dark:hover:bg-neutral-85 text-neutral-70 dark:text-neutral-30'
                  }`}
                >
                  {url.replace('https://', '').replace('http://', '')}
                </button>
              ))}
            </div>
          </div>

          <div>
            <button
              onClick={testBrowserCompatibility}
              className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded text-sm transition-colors"
            >
              🔍 Check Browser Compatibility
            </button>
            <p className="text-xs text-neutral-600 dark:text-neutral-400 mt-1">Results will be logged to console</p>
          </div>

          <div className="p-3 bg-neutral-5 dark:bg-neutral-85 rounded text-xs">
            <div className="grid grid-cols-2 gap-2 text-neutral-70 dark:text-neutral-30">
              <div>
                <strong>Origin:</strong> {window.location.origin}
              </div>
              <div>
                <strong>Protocol:</strong> {window.location.protocol}
              </div>
              <div>
                <strong>User Agent:</strong> {getBrowserName()}
              </div>
              <div>
                <strong>Cookies:</strong> {navigator.cookieEnabled ? 'Enabled' : 'Disabled'}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
function getBrowserName() {
  const ua = navigator.userAgent;

  if (ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('OPR') || ua.includes('Opera')) return 'Opera';

  return 'Desconhecido';
}
